import React from "react";

const Check = () => (
  <svg
    width="27"
    height="19"
    viewBox="0 0 27 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5139 0L9.87541 16.3403L1.48581 7.57815L0 9.13138L9.13265 18.6784C9.33526 18.8902 9.60542 19 9.87556 19C10.1457 19 10.4158 18.8902 10.6185 18.6784L27 1.55363L25.5139 0Z"
      fill="#FEFEFE"
    />
  </svg>
);

export default Check;
